export default "__VITE_ASSET__e5e47277__"